import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star } from 'lucide-react';
interface HeroProps {
  scrollToPricing: () => void;
}
export const Hero: React.FC<HeroProps> = ({
  scrollToPricing
}) => {
  return <section className="relative bg-gradient-to-b from-barre-blush to-white pt-20 pb-16 lg:pt-28 lg:pb-24 overflow-hidden" data-id="element-67">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-69">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-8 tracking-tight" data-id="element-70">
            Sumá <span className="text-barre-pink" data-id="element-71">Barre</span> y llevá tu
            estudio al siguiente nivel
          </h1>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative mb-8" data-id="element-72">
            <div className="absolute inset-0 bg-barre-blushDark rounded-full blur-3xl opacity-50 animate-pulse" data-id="element-73"></div>
            <img src="https://cdn.magicpatterns.com/uploads/iyzYHFD8WUJ3vu8jXWwGZf/WhatsApp_Image_2026-06-13_at_9.15.50_PM-removebg-preview.png" alt="Pack Digital Barre: La evolución de tu estudio" className="relative z-10 w-full max-w-xl mx-auto drop-shadow-2xl cursor-pointer transform hover:scale-105 transition-transform duration-500" onClick={scrollToPricing} data-id="element-74" />
          </motion.div>

          <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-75">
            El pack definitivo: estructura de clases, equipamiento, música y
            lanzamiento. Suma barre sin complicaciones.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-76">
            <button onClick={scrollToPricing} className="bg-barre-pink hover:bg-barre-pinkHover text-white font-bold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 text-lg" data-id="element-77">
              Quiero mejorar mi estudio
              <ArrowRight className="w-5 h-5" data-id="element-78" />
            </button>
          </div>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-3" data-id="element-79">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-barre-blush text-barre-pink font-medium text-sm border border-barre-border" data-id="element-80">
              <span className="flex gap-1" data-id="element-81">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-82" />)}
              </span>
              4.9/5 estrellas
            </div>
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-barre-blush text-barre-pink font-medium text-sm border border-barre-border" data-id="element-83">
              Para dueñas de estudios en Argentina
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};